(function () {
  const setAttributeIfNeeded = (element, name, value) => {
    if (element.getAttribute(name) !== value) {
      element.setAttribute(name, value);
    }
  };

  const removeAttributeIfNeeded = (element, name) => {
    if (element.hasAttribute(name)) {
      element.removeAttribute(name);
    }
  };

  const syncDialogState = (dialog, isOpen) => {
    if (!dialog) return;

    if (isOpen) {
      removeAttributeIfNeeded(dialog, 'inert');
      setAttributeIfNeeded(dialog, 'aria-hidden', 'false');
    } else {
      setAttributeIfNeeded(dialog, 'inert', '');
      setAttributeIfNeeded(dialog, 'aria-hidden', 'true');
    }
  };

  const syncClosedDrawers = () => {
    const isMobileMenuOpen = document.documentElement.classList.contains('nav-open');
    const isMobileViewport = window.matchMedia('(max-width: 1024px)').matches;

    document.querySelectorAll('.bls__canvas-mb-menu').forEach((dialog) => {
      if (!isMobileViewport) {
        removeAttributeIfNeeded(dialog, 'role');
        removeAttributeIfNeeded(dialog, 'aria-modal');
        removeAttributeIfNeeded(dialog, 'tabindex');
        removeAttributeIfNeeded(dialog, 'inert');
        setAttributeIfNeeded(dialog, 'aria-hidden', 'false');
        return;
      }

      setAttributeIfNeeded(dialog, 'role', 'dialog');
      setAttributeIfNeeded(dialog, 'aria-modal', 'true');
      setAttributeIfNeeded(dialog, 'tabindex', '-1');
      syncDialogState(dialog, isMobileMenuOpen);
    });

    document.querySelectorAll('.bls-minicart-wrapper[role="dialog"]').forEach((dialog) => {
      const cart = dialog.closest('#bls-header_minicart, .header_minicart');
      syncDialogState(dialog, Boolean(cart && cart.classList.contains('bls__opend-popup-header')));
    });

    document.querySelectorAll('[data-search-dialog][role="dialog"]').forEach((dialog) => {
      const form = dialog.closest('#search-form');
      syncDialogState(dialog, Boolean(form && form.classList.contains('bls__opend-popup-header')));
    });
  };

  const scheduleSync = () => {
    window.requestAnimationFrame(syncClosedDrawers);
  };

  document.addEventListener('DOMContentLoaded', syncClosedDrawers);
  window.addEventListener('load', syncClosedDrawers);
  window.addEventListener('resize', scheduleSync);
  document.addEventListener('click', scheduleSync, true);
  document.addEventListener('keyup', scheduleSync, true);

  new MutationObserver(scheduleSync).observe(document.documentElement, {
    attributes: true,
    childList: true,
    subtree: true,
    attributeFilter: ['class', 'style', 'aria-hidden'],
  });
})();
